export class StudentRegistrationForm {
    constructor() {
        this.id = "00000000-0000-0000-0000-000000000000";
    }
    id: string;
    formName: string;
    description: string;
}